//GeneratorFlag:[NoChange]
import BlogContent from './blog-content';

export default {BlogContent}
export{BlogContent}